import styled, { keyframes, css } from "styled-components";

export const SWAP_DURATION_MS = 750;

const slideFadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const slideFadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

export const SwapStage = styled.span`
  white-space: nowrap;

  ${({ $align, $inline }) => {
    if ($align === "center") {
      return css`
        display: inline-grid;
        align-items: center;
        justify-items: center;
      `;
    }

    if ($inline) {
      return css`
        position: relative;
        display: inline;
      `;
    }
    return css`
      position: relative;
      display: inline-flex;
      align-items: center;
    `;
  }}
`;

export const SwapFace = styled.span`
  display: inline-flex;
  align-items: center;
  animation: ${({ $exiting }) => ($exiting ? slideFadeOut : slideFadeIn)}
    ${SWAP_DURATION_MS}ms ${({ theme }) => theme.easing.entering} forwards;

  ${({ $align, $exiting }) => {
    if ($align === "center") {
      // both faces occupy the same cell so they overlap and stay co-centered
      return css`
        grid-area: 1 / 1;
      `;
    }
    if ($exiting) {
      return css`
        position: absolute;
        top: 0;
        left: 0;
      `;
    }
    return null;
  }}

  ${({ $exiting }) =>
    $exiting &&
    css`
      pointer-events: none;
    `}

  ${({ $inline }) =>
    $inline &&
    css`
      display: inline;
      align-items: initial;
    `}
`;
